import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { addDoc, collection, query, where, onSnapshot, getDocs, limit, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import Lodinging from "../components_root/loading.jsx"; 
import { Helmet } from "react-helmet";
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './dashboard.css';
import { Toast } from '../components_root/ToastContext';
import { VscDashboard } from "react-icons/vsc";
import { GoDependabot } from "react-icons/go";
import { GrDeliver } from "react-icons/gr";
import { MdAccountCircle, MdAnalytics, MdBusiness, MdBusinessCenter, MdDashboard, MdFileUpload, MdHome, MdLocationCity, MdMenu, MdMonitor, MdOutlineAnalytics, MdProductionQuantityLimits, MdSettings, MdSettingsAccessibility, MdTraffic } from "react-icons/md";
import Settings_seo from "./settings";
import Monitor_seo from "./monitor";
import Seo_tool from "./seo-tools";
import Analytics_seo from "./analytics";
import Orders_management from "./orders_management.jsx";
import Traffic_control_seo from "./traffic-control";
import Account from "../profile/account";
import Edit_company from "./edit-company";
import Companies_list from "./companies-list.jsx";
import Products_list from "./products-list.jsx"; 
import Products_Edit from "./products-edit.jsx";
import File_uploaded from "./file-uploaded.jsx";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};


export default function Dashboard() {
    const location = useLocation();
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [collapsed, setCollapsed] = useState(false);
    const [activeTab, setActiveTab] = useState("monitor");
    const [userlogin, setuserlogin] = useState(false);
    const [guid, setguid] = useState('');
    const [user, setUser] = useState(null);
    const [companyData, setCompanyData] = useState([]);
    const [uid, setUid] = useState("");
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const uId = params.get("uid");

    }, [location]);
    useEffect(() => {
        const uId = Cookies.get("select_company_uid");
        if (uId) {
            setUid(uId);
        } else {
            navigate("/dashboard?menu=companieslist");
        }
 
        }, []);
 

    useEffect(() => {
        const fetchCompanies = async () => {
            setIsLoading(true);
            try {
                const q = query(
                    collection(db, "companies"),
                    where("uid", "==", Cookies.get("select_company_uid")),
                    where("guid", "==", Cookies.get("guid"))
                );

                const snapshot = await getDocs(q);

                if (snapshot.empty) {
                    console.log("No companies found");
                    setCompanyData([]);
                    return;
                }
                const docs = await Promise.all(
                    snapshot.docs.map(async (docSnap) => {
                        const docData = docSnap.data();

                        // fetch child collection "fields"
                        const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                        let child = {};
                        fieldsSnap.forEach((fieldDoc) => {
                            const { fieldName, fieldValue } = fieldDoc.data();
                            child[fieldName] = fieldValue;
                        });

                        const fullData = { uid: docSnap.id, ...docData, child };

                        return fullData;
                    })
                );

                setCompanyData(docs); // update state
            } catch (err) {
                console.error("Error fetching companies:", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCompanies();
    }, []);


    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setCollapsed(true);
            } else {
                setCollapsed(false);
            }
        };

        // Run once on mount
        handleResize();

        // Attach resize listener
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tab = params.get("menu");
        if (tab) setActiveTab(tab.toLowerCase());
    }, []);
    const setTabInUrl = (tab) => {
        const params = new URLSearchParams(window.location.search);
        params.set("menu", tab);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, "", "" + newUrl);
    };

    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="dashboard-body">
                <div className="dashboard-menu" >
                    <div className={`menu-div border-bottom ${activeTab === "editcompany" ? "activemenu" : ""}`}  >
                        <table>
                            <tr>
                                <td>
                                    <div className="menu-btn" onClick={() => setCollapsed(!collapsed)}><MdMenu className="icon" /></div>
                                </td>
                            </tr>

                        </table>

                        {!collapsed && (

                            <div className="menu-title"
                                onClick={() => { setActiveTab("editcompany"); setTabInUrl("editcompany"); }}
                            >
                                <table>
                                    <tr>
                                        <td>
                                            <div className="fcap text-h1  text-right bold">{companyData.length > 0 ? companyData[0].slug : "Unknown"}</div>
                                        </td>
                                        <td width={25}>
                                            <div className="menu-btn"><MdSettings className="icon" /></div></td>
                                    </tr>
                                </table>
                            </div>
                        )}
                    </div>
                    <div className={`menu-div ${activeTab === "monitor" ? "activemenu" : ""}`}
                        onClick={() => { setActiveTab("monitor"); setTabInUrl("monitor"); }}
                    >
                        <div className="menu-btn"><VscDashboard className="icon" /></div>
                        {!collapsed && (
                            <div className="menu-title text-h2">Monitor</div>
                        )}
                    </div>
                    {/* <div className={`menu-div ${activeTab === "seo" ? "activemenu" : ""}`}
                        onClick={() => { setActiveTab("seo"); setTabInUrl("seo"); }}
                    >
                        <div className="menu-btn"><GoDependabot className="icon" /></div>
                        {!collapsed && (
                            <div className="menu-title text-h2">SEO keywords</div>
                        )}
                    </div> */}
                    <div className={`menu-div ${activeTab === "analytics" ? "activemenu" : ""}`}
                        onClick={() => { setActiveTab("analytics"); setTabInUrl("analytics"); }}
                    >
                        <div className="menu-btn"><MdOutlineAnalytics className="icon" /></div>
                        {!collapsed && (
                            <div className="menu-title text-h2">Analytics</div>
                        )}
                    </div>
                    <div className={`menu-div ${activeTab === "orders_management" ? "activemenu" : ""}`}
                        onClick={() => { setActiveTab("orders_management"); setTabInUrl("orders_management"); }}
                    >
                        <div className="menu-btn"><GrDeliver className="icon" /></div>
                        {!collapsed && (
                            <div className="menu-title text-h2">Orders management</div>
                        )}
                    </div>
                    <div className={`menu-div ${activeTab === "traffic-control" ? "activemenu" : ""}`}
                        onClick={() => { setActiveTab("traffic-control"); setTabInUrl("traffic-control"); }}
                    >
                        <div className="menu-btn"><MdSettingsAccessibility className="icon" /></div>
                        {!collapsed && (
                            <div className="menu-title text-h2">Traffic control</div>
                        )}
                    </div>
                    <div className={`menu-div ${activeTab === "companieslist" ? "activemenu" : ""}`}
                        onClick={() => { setActiveTab("companieslist"); setTabInUrl("companieslist"); }}
                    >
                        <div className="menu-btn"><MdBusiness className="icon" /></div>
                        {!collapsed && (
                            <div className="menu-title text-h2">Companies List</div>
                        )}
                    </div>
                    <div className={`menu-div ${activeTab === "productslist" ? "activemenu" : ""}`}
                        onClick={() => { setActiveTab("productslist"); setTabInUrl("productslist"); }}
                    >
                        <div className="menu-btn"><MdProductionQuantityLimits className="icon" /></div>
                        {!collapsed && (
                            <div className="menu-title text-h2">Products List</div>
                        )}
                    </div>
                    <div className={`menu-div ${activeTab === "files" ? "activemenu" : ""}`}
                        onClick={() => { setActiveTab("files"); setTabInUrl("files"); }}
                    >
                        <div className="menu-btn"><MdFileUpload className="icon" /></div>
                        {!collapsed && (
                            <div className="menu-title text-h2">File uploaded</div>
                        )}
                    </div>
                    <div className={`menu-div ${activeTab === "account-profile" ? "activemenu" : ""}`}
                        onClick={() => { setActiveTab("account-profile"); setTabInUrl("account-profile"); }}
                    >
                        <div className="menu-btn"><MdAccountCircle className="icon" /></div>
                        {!collapsed && (
                            <div className="menu-title text-h2">Account Profile</div>
                        )}
                    </div>
                    <div className={`menu-div ${activeTab === "admin" ? "activemenu" : ""}`}
                        onClick={() => { setActiveTab("admin"); setTabInUrl("admin"); }}
                    >
                        <div className="menu-btn"><MdDashboard className="icon" /></div>
                        {!collapsed && (
                            <div className="menu-title text-h2">Admin</div>
                        )}
                    </div>
                </div>
                <div className="dashboard-container">
                    {activeTab === "settings" && <Settings_seo />}
                    {activeTab === "editcompany" && <Edit_company />}
                    {activeTab === "monitor" && <Monitor_seo />}
                    {activeTab === "seo" && <Seo_tool />}
                    {activeTab === "analytics" && <Analytics_seo />}
                    {activeTab === "orders_management" && <Orders_management />}
                    {activeTab === "traffic-control" && <Traffic_control_seo />}
                    {activeTab === "companieslist" && <Companies_list />}
                    {activeTab === "productslist" && <Products_list />}
                    {activeTab === "files" && <File_uploaded />}

                    {activeTab === "productsedit" && <Products_Edit />}
                    {activeTab === "account-profile" && <Account />} 
                </div>
            </div>


        </div>
    );
}
